export default "__VITE_ASSET__DCN5wB3i__"